<template>
  <div id="bottom">
    <p class="introduce">
      <router-link to="/about">关于我们</router-link>
      <span class="line">|</span>
      <router-link to="/ourservices">我们的服务</router-link>
    </p>
    <p class="copyRight">Copyright &copy;上海友瀚信息科技有限公司 &nbsp;&nbsp;沪ICP备18013225号-1 </p>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less">
  #bottom{
    // height: 100px;
    height: 170px;
    background-color: #414458;
    text-align: center;
    overflow: hidden;
    .introduce{
      // margin-top: 30px;
      margin-top: 60px;
      color: #fff;
      a{
        color: #fff;
        font-size: 14px;
      }
    }
    .copyRight{
      // margin-top: 10px;
      margin-top: 25px;
      color: #9ea0a7;
      font-size: 13px
    }
    .line{
      padding: 0 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/bottom/Bottom.vue